<template>
    <form @submit.prevent="submit" id="productEditForm">
        <tabs class="tabs-simple">
            <tab id="basic"
                name="Alap adatok">
                <div class="row m-1">
                    <div class="col-8">
                        <div class="card">
                            <div class="card-header">
                                Leírás
                            </div>
                            <div class="card-body">
                                <editor ref="editor"
                                    :config="editorConfig">
                                </editor>
                            </div>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="card">
                            <div class="card-header">
                                Közzététel
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>Állapot:</label>
                                    <select class="form-control" v-model="status">
                                        <option value="draft">Vázlat</option>
                                        <option value="published">Publikus</option>
                                        <option value="timed">Időzített</option>
                                    </select>
                                </div>

                                <div class="form-group" :class="{'collapse': !showPublishTiming}">
                                    <label>
                                        Publikálás időpontja:
                                    </label>

                                    <datetime type="datetime"
                                        v-model="product.published_at"
                                        :min-datetime="(new Date).toISOString()"
                                        format="yyyy-MM-dd HH:mm"
                                        input-class="form-control">
                                    </datetime>
                                </div>

                                <div class="form-group">
                                    <label for="typeInput">Típus</label>
                                    <select id="typeInput" class="form-control" v-model="product.product_type">
                                        <option value="0">Egyszerű termék</option>
                                        <option value="1">Csoportosított termék</option>
                                        <option value="2">Variálható termék</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-body">
                                <div class="form-group">
                                    <label for="titleInput">Név:</label>
                                    <input type="text"
                                        class="form-control"
                                        id="titleInput"
                                        v-model="product.title">
                                </div>

                                <div class="form-group">
                                    <label for="slugInput">Slug:</label>
                                    <input type="text"
                                        class="form-control"
                                        id="slugInput"
                                        v-model="product.slug"
                                        @input="updateCanonical">
                                </div>

                                <div class="form-group">
                                    <label for="descriptionInput">Meta leírás:</label>
                                    <textarea class="form-control"
                                        id="descriptionInput"
                                        rows="4"
                                        v-model="product.description">
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>

            <tab id="categorization" name="Kategorizálás">
                <div class="card">
                    <div class="card-header">
                        Kategória
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <treeselect v-model="product.category"
                                :options="categories"
                                :multiple="false"
                                :clearable="false"
                                :normalizer="normalizeCategories">
                            </treeselect>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        Címkék
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <treeselect v-model="product.tags"
                                :options="tags"
                                :multiple="true"
                                :normalizer="normalizeTags">
                            </treeselect>
                        </div>
                    </div>
                </div>
            </tab>


            <tab id="properties"
                name="Tulajdonságok"
                v-if="product.id">
                <attribute-editor v-if="product.relations && product.relations.attributes"
                    :attributes="product.relations.attributes"
                    :units="meta && meta.units ? meta.units : {}"
                    :tooltipHeader="tooltips.attributes">
                </attribute-editor>
            </tab>


            <tab id="media"
                name="Média">
                <media-editor :images="product.images"
                    @add="showLibrary(true)">
                </media-editor>
            </tab>

            <tab id="prices"
                name="Árak"
                v-if="product.id && product.product_type!=2">
                <price-editor :prices="product.relations.prices"
                    :current="product.relations.currentPrice"
                    :product="product"
                    @updateCurrent="updateCurrentPrice">
                </price-editor>
            </tab>

            <tab id="bundle"
                name="Termékek"
                v-if="product.id && product.product_type==1">
                <bundle-editor :product="product"/>
            </tab>

            <tab id="variations"
                name="Variációk"
                v-if="product.id && product.product_type==2">
                <variation-editor :product="product"
                    :units="meta && meta.units ? meta.units : {}"
                    :tooltipHeader="tooltips.attributes">
                </variation-editor>
            </tab>

            <tab id="stock"
                name="Készlet">
                <stock-editor :product="product" :dirty="dirty" @updateStock="updateStock"/>
            </tab>
        </tabs>

        <vue-medialibrary-manager :selectable="true"
            v-if="showMediaLibrary"
            @close="showMediaLibrary=false"
            @select="selectImage">
        </vue-medialibrary-manager>
    </form>
</template>

<script>
import Vue from 'vue'
import Editor from 'vue-editor-js'
import ls from '../../services/ls.js'
import store from '../../services/vuex'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import { Tabs, Tab } from 'vue-tabs-component'
import Treeselect from '@riophae/vue-treeselect'
import toolConfig from '../../helpers/toolConfig.js'
import MediaEditor from '../../components/MediaEditor'
import StockEditor from '../../components/StockEditor'
import PriceEditor from '../../components/PriceEditor'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import BundleEditor from '../../components/BundleEditor'
import MediaLibrary from '../../components/MediaLibrary'
import AttributeEditor from '../../components/AttributeEditor'
import VariationEditor from '../../components/VariationEditor'


Vue.use(Editor)
Vue.use(MediaLibrary, {
    API_URL: '/api/admin/media'
});

export default {
    props: {
        original: { type: [Object], required: true },
        save: { type: [Function], required: true },
    },
    components: {
        Tab,
        Tabs,
        Datetime,
        Treeselect,
        MediaEditor,
        StockEditor,
        PriceEditor,
        BundleEditor,
        AttributeEditor,
        VariationEditor,
    },
    data () {
        return {
            product: {
                title: 'Új termék',
                slug: 'uj-termek',
                description: '',
                published_at: null,
                canonical: 'products/uj-bejegyzes',
                images: [],
                affiliate: null,
                product_type: 0,
                category: null,
                tags: [],
                relations: [],
            },
            dirty: false,
            loadStatus: 0,
            status: 'draft',
            showPublishTiming: false,
            site: null,
            domain: null,
            categories: [],
            tags: [],
            libraryTarget: 'content',
            showMediaLibrary: false,
            selectCallback: () => {},
            editorConfig: {
                tools: toolConfig.get(this),
                onReady: () => {
                    this.loadStatus++
                },
                data: {},
                autofocus: true,
                placeholder: 'Write your content here'
            },
            tooltips: {
                attributes: {
                    content: 'A megadott azonosítókhoz létre kell hozni egy fordítást is a Vezérlőpult/Fordítások menüpontban'
                }
            }
        }
    },
    computed: {
        meta(){
            return store.state.products.meta
        }
    },
    methods: {
        showLibrary(gallery=false){
            this.libraryTarget = gallery ? 'gallery' : 'content'
            this.showMediaLibrary = true
        },
        setSelectCallback(f){
            this.selectCallback = f
        },
        selectImage(image){
            if(this.libraryTarget=='gallery'){
                image.highlight = false
                this.product.images.push(image)
            }else{
                this.selectCallback(image)
            }

            this.showMediaLibrary = false
        },
        updateCanonical(){
            this.product.canonical = `${this.domain}/products/${this.product.slug}`
        },
        loadRelations(){
            if(this.product.relations == undefined){
                this.product.relations = {}
            }

            if(this.product.relations.attributes == undefined) {
                this.product.relations.attributes = []
            }

            this.product.images = this.product.relations?.images ? this.product.relations.images : []
        },
        loadEditor(){
            let data = this.product.relations.content.map(o => {
                return o.content
            })

            this.$refs.editor.state.editor.render({
                blocks: data,
                version: '2.8.1',
                time: (new Date).getTime()
            })
        },
        loadCategories(){
            axios.get('/api/admin/categories', {
                params: {
                    with: 'children',
                    filters: {
                        site: this.site,
                        parent: 'products',
                    },
                    size: 1000
                }
            })
            .then(results => {
                this.categories = results.data.data
            })
        },
        normalizeCategories(node){
            var cat = {
                id: node.id,
                label: node.name ? node.name : '',
            }

            if(node?.relations?.children.length > 0){
                cat.children = node.relations.children
            }

            return cat
        },
        loadTags(){
            axios.get('/api/admin/tags', {
                params: {
                    filters: {
                        site: this.site,
                    }
                }
            })
            .then(results => {
                this.tags = results.data.data
            })
        },
        normalizeTags(node){
            return {
                id: node.id,
                label: node.name,
            }
        },
        submit(){
            this.$emit('saving', true)
            this.dirty = false
            this.$refs.editor.state.editor.save().then(data => {
                this.save(this.product, data.blocks)
            })
        },
        updateCurrentPrice(price){
            this.product.relations.currentPrice = price
        },
        updateStock(stock){
            this.product.relations.stock = stock
        }
    },
    created() {
        this.site = ls.get('site')
        this.domain = ls.get('siteDomain')
        this.loadCategories()
        this.loadTags()
    },
    watch: {
        status(newValue){
            if(newValue == 'draft'){
                this.product.published_at = null
            }else if(newValue == 'published' || !this.product.published_at){
                this.product.published_at = (new Date).toISOString()
            }

            this.showPublishTiming = newValue == 'timed'
        },
        original(newValue){
            if(!this.original) return

            this.loadStatus++
        },
        product: {
            handler(value){
                this.dirty = true
            },
            deep: true
        },
        loadStatus(newValue){
            if(newValue < 2) return

            this.product = this.original

            this.loadRelations()

            this.loadEditor()

            this.updateCanonical()

            this.product.category = this.product.relations?.category.id

            this.product.tags = this.product.relations.tags
                ? this.product.relations.tags.map(tag => tag.id)
                : []

            if(this.product.published_at != null){
                let date = new Date(this.product.published_at)
                let now = new Date()

                if(date > now){
                    this.status = 'timed'
                    this.product.published_at = date.toISOString()
                }else{
                    this.status = 'published'
                }
            }
        }
    }
}
</script>

<style scoped>
.table td{
    border-top: none;
}
</style>
